import { Box, styled } from '@mui/material';

export const MainWrapper = styled('main')`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0px;
  height: 100vh;
  width: 100%;
`;

export const MainContainer = styled(Box)`
  display: flex;
  flex: 1;
  min-height: 100vh;
`;

export const WrapperWithOverflow = styled(Box)`
  display: flex;
  overflow: auto;
  width: 100%;
  justify-content: center;
`;
